export const GET_ADDRESSES_SUCCESS = 'GET_ADDRESSES_SUCCESS';
export const SET_ADDRESS_DATA_LOADING = 'SET_ADDRESS_DATA_LOADING';
export const SET_INVALID_ADDRESS_FIELDS = 'SET_INVALID_ADDRESS_FIELDS';
export const SET_SUGGESTED_ADDRESSES = 'SET_SUGGESTED_ADDRESSES';
export const CLEAR_INVALID_ADDRESS_FIELDS_AND_ERRORS = 'CLEAR_ADDRESS_INVALID_FIELDS_AND_ERRORS';
export const CLEAR_ADDRESS_FORM_ITEM = 'CLEAR_ADDRESS_FORM_ITEM';
export const ON_TOGGLE_IS_ALSO_BILLING = 'ON_TOGGLE_IS_ALSO_BILLING';
export const SET_ADDRESS_FORM_ITEM = 'SET_ADDRESS_FORM_ITEM';
export const SET_TEMP_ADDRESS_FAILURE_MSG = 'SET_TEMP_ADDRESS_FAILURE_MSG';
export const SET_TEMP_ADDRESS_SUCCESS_MSG = 'SET_TEMP_ADDRESS_SUCCESS_MSG';
export const SET_EDIT_OF_INACTIVE_ADDRESS_ERROR = 'SET_EDIT_OF_INACTIVE_ADDRESS_ERROR';
export const ADDRESS_SAW_ADDRESS_FORM_WITH_AAC = 'ADDRESS_SAW_ADDRESS_FORM_WITH_AAC';
export const ADDRESS_HAS_LOADED_AAC_SUGGESTIONS = 'ADDRESS_HAS_LOADED_AAC_SUGGESTIONS';
export const ADDRESS_HAS_SELECTED_AAC_SUGGESTION = 'HAS_SELECTED_AAC_SUGGESTION';
export const SET_ADDRESS_LAT_LONG = 'SET_ADDRESS_LAT_LONG';
export const SET_ADDRESS_AUTOCOMPLETE_SUGGESTIONS = 'SET_ADDRESS_AUTOCOMPLETE_SUGGESTIONS';
export const ADDRESS_CLEAR_AAC_DATA = 'ADDRESS_CLEAR_AAC_DATA';
